import React, { useRef, useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "./ckeditor.css";

const CkEditorInput = ({
  value = "",
  onChange = () => {},
  height = 400,
  width = "100%",
  customProps,
  ...rest
}) => {
  const editorRef = useRef(null);

  useEffect(() => {
    // Manually sync if value changes after mount
    if (editorRef.current && value !== editorRef.current.getData()) {
      editorRef.current.setData(value || "");
    }
  }, [value]);
  const maxChars = customProps?.maxChars ?? 5000;
  const [count, setCount] = useState(0);

  const getPlain = (html) =>
    (html || "")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

  useEffect(() => {
    setCount(getPlain(value).length);
  }, [value]);

  const handleChange = (nextHtml) => {
    // Update parent
    onChange?.(nextHtml);
    // Update counter
    setCount(getPlain(nextHtml).length);
  };

  return (
    <div style={{ minHeight: height, width }}>
      <CKEditor
        editor={ClassicEditor}
        data={value}
        onReady={(editor) => {
          editorRef.current = editor;
          try {
            const editableElement = editor?.ui?.getEditableElement();
            if (editableElement) {
              editableElement.style.minHeight = `${height}px`;
              editableElement.style.width =
                typeof width === "number" ? `${width}px` : width;
            }
          } catch (e) {
            console.warn("Styling CKEditor failed:", e);
          }
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          onChange(data);
        }}
        config={{
          placeholder: "Enter description...",
          toolbar: [
            "heading",
            "|",
            "bold",
            "italic",
            "link",
            "bulletedList",
            "numberedList",
            "|",
            "insertTable",
            "blockQuote",
            "undo",
            "redo",
          ],
          table: {
            contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
          },
        }}
      />

      {rest.editor}
      <div
        className={`text-sm text-right ${
          count > maxChars ? "text-danger" : "text-gray-500"
        }`}
      >
        {count}/{maxChars}
      </div>
    </div>
  );
};

export default CkEditorInput;
